import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingScreen } from './LoadingScreen';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { loading, user, staff, signOut } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;

  if (!staff) {
    return (
      <main className="centered-page">
        <section className="auth-card">
          <p className="eyebrow">Accès refusé</p>
          <h1>Ce compte n’est pas administrateur de Findex.</h1>
          <p>
            Ajoute l’UUID de ce compte dans la table <code>admin_users</code>, puis reconnecte-toi.
          </p>
          <button className="button secondary" onClick={() => void signOut()}>
            Se déconnecter
          </button>
        </section>
      </main>
    );
  }

  return children;
}
